import type { LotteryRecordListItem } from './productList';

export interface FeaturedLotteryCard {
    id: string;
    title: string;
    tipText: string;
    buttonText: string;
    countdownTarget: number;
}

export const featuredRecord: FeaturedLotteryCard = {
    id: 'featured-1',
    title: '中秋转好运，月满抽锦鲤',
    tipText: '中秋转好运，月满抽锦鲤 | 留言晒图赢 vivo X300 Ultra',
    buttonText: '去抽奖',
    countdownTarget: Date.now() + 24 * 60 * 60 * 1000 + 6 * 60 * 60 * 1000 + 11 * 60 * 1000,
};

export const lotteryRecordMockList: LotteryRecordListItem[] = [
    {
        id: 'record-ongoing-1',
        title: '中秋转好运，月满抽锦鲤',
        participantText: '2992人参与',
        endTimeText: '04-30 11:00 结束',
        resultText: '去抽奖',
        resultType: 'ongoing',
        tipText: '中秋转好运，月满抽锦鲤 | 留言晒图赢 vivo X300 Ultra',
    },
    {
        id: 'record-lose-1',
        title: '中秋转好运，月满抽锦鲤',
        participantText: '2992人参与',
        endTimeText: '04-30 11:00 结束',
        resultText: '谢谢参与',
        resultType: 'lose',
        tipText: '中秋转好运，月满抽锦鲤 | 留言晒图赢 vivo X300 Ultra',
    },
    {
        id: 'record-win-1',
        title: '中秋转好运，月满抽锦鲤',
        participantText: '2992人参与',
        endTimeText: '04-30 11:00 结束',
        resultText: '恭喜你中奖啦',
        resultType: 'win',
        tipText: '中秋转好运，月满抽锦鲤 | 留言晒图赢 vivo X300 Ultra',
    },
];
